/**
 * Ensures that all items in the items array appear in the collection array.
 * @param items The array to check that all items are in the collection.
 * @param collection The array to compare items against.
 * @returns Returns true if all elements in the item array are in the collection array,
 *          false otherwise.
 */
export function areAllItemsInCollection(items: unknown[], collection: unknown[]): boolean {
  if (!Array.isArray(items)) {
    throw new Error('items must be an array');
  }

  if (!Array.isArray(collection)) {
    throw new Error('collection must be an array');
  }

  return items.every((item) => collection.includes(item));
}

/**
 * Compares two arrays and return the items that are unique to either side.
 * @param first The first array used in the comparison.
 * @param second The second array used in the comparison.
 * @returns Returns an array of items that are unique between the two arrays.
 */
export function diffArray<T = unknown>(first: T[], second: T[]): T[] {
  if (!Array.isArray(first) || !Array.isArray(second)) {
    throw new Error('You need to provide arrays to use this function.!');
  }

  const firstDiff = first.filter((item) => !second.includes(item));
  const secondDiff = second.filter((item) => !first.includes(item));

  const diff = firstDiff.concat(secondDiff);
  return diff;
}
